import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';
import { EVehicleAssetType } from '@/context/borrower';
import { getGlassAssetType } from '@/utils/glassGuideHelpers';

export async function getVariant(
    partner: string,
    year: number | undefined,
    make: string | undefined,
    model: string | undefined,
    assetType?: EVehicleAssetType
): Promise<string[]> {
    const url = `/api/asset/select/${partner}/${getGlassAssetType(assetType)}/${year}/${make}/${model}`;
    return postUrl<string[]>(url, { billingContext: buildBillingContext() });
}
